"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=new Map;exports.makeUniqueId=function(t){var n=e.get(t)||1;return e.set(t,n+1),"".concat(t,":").concat(n,":").concat(Math.random().toString(36).slice(2))};
//# sourceMappingURL=makeUniqueId.js.map
